import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import type { EventData } from '../../types'

export const reviewModel = ({
  reviewPosition,
  averageRate,
  countryCode,
  isReviewFromCurrentCountry,
  isReviewTranslated,
  isEdited = false,
  isHighlighted = false,
}: EventData) => {
  return removeEmptyValuesInObject({
    review_position_impression: reviewPosition,
    review_score_impression: averageRate,
    review_from_country: isReviewFromCurrentCountry,
    review_language: countryCode,
    review_translated: isReviewTranslated,
    is_edited: isEdited,
    is_highlighted: isHighlighted,
  })
}

export const globalRatingModel = ({ averageRate, count }: EventData) => {
  return removeEmptyValuesInObject({
    average_rate: averageRate,
    reviews_total_count: count,
  })
}
